import { AccessComparison } from './AccessComparison';
import { AccessComparisonFields } from './AccessComparisonFields';
import { DataAccess } from './DataAccess';
import { FeatureFlag } from '@sonar-software/sonar-core';
import { FeatureRouteWrapper } from '@ui/features';
import React from 'react';
import { ViewArea } from '@ui/general';

import { AccessAudit, AccessAuditQueryParams } from './AccessAudit';
import { AccessComparisonObjectQueryParams, AccessComparisonQueryParams } from '@hooks';
import { AccessExplainer, AccessExplainerQueryParams } from './AccessExplainer';
import { AccessExplainerFields, AccessExplainerObjectQueryParams } from './AccessExplainerFields';
import { BASE_ROUTES, PARAMS } from '@sonar-software/sonar-ts-constants';
import { Route, Routes } from 'react-router';

export type DataAccessRouteParams =
	AccessAuditQueryParams &
	AccessExplainerQueryParams &
	AccessExplainerObjectQueryParams &
	AccessComparisonObjectQueryParams &
	AccessComparisonQueryParams & {
		id?: string;
	};

export const DataAccessView: React.FC = () =>
	<ViewArea
		collapseSidebar
		direction='horizontal'
		fullWidth
		id='data-access-view-area'
		showPeriscopes>
		<Routes>
			<Route
				element={
					<FeatureRouteWrapper feature={ FeatureFlag.AccessAudit }>
						<AccessAudit />
					</FeatureRouteWrapper>
				}
				path={ `${BASE_ROUTES.ACCESS_AUDIT}/${PARAMS.OBJECT_ID}` } />
			<Route
				element={
					<FeatureRouteWrapper feature={ FeatureFlag.AccessExplainer }>
						<AccessExplainerFields />
					</FeatureRouteWrapper>
				}
				path={ `${BASE_ROUTES.ACCESS_EXPLAINER}/${PARAMS.ID}/${PARAMS.OBJECT_ID}` } />
			<Route
				element={
					<FeatureRouteWrapper feature={ FeatureFlag.AccessExplainer }>
						<AccessExplainer />
					</FeatureRouteWrapper>
				}
				path={ `${BASE_ROUTES.ACCESS_EXPLAINER}/${PARAMS.ID}` } />
			<Route
				element={
					<FeatureRouteWrapper feature={ FeatureFlag.AccessComparison }>
						<AccessComparisonFields />
					</FeatureRouteWrapper>
				}
				path={ `${BASE_ROUTES.ACCESS_COMPARISON}/${PARAMS.OBJECT_ID}` } />
			<Route
				element={
					<FeatureRouteWrapper feature={ FeatureFlag.AccessComparison }>
						<AccessComparison />
					</FeatureRouteWrapper>
				}
				path={ `${BASE_ROUTES.ACCESS_COMPARISON}` } />
			<Route
				element={ <DataAccess /> }
				path='*' />
		</Routes>
	</ViewArea>;
